import react, {useEffect, useMemo} from 'react';
import MyTable from '../components/myTable';
import {useSelector} from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Cookie from 'react-cookies';
import { FaPlus } from 'react-icons/fa';
import { getHighlights, userList } from '../../api/api';

const Highlights = () => {
    // const marginLeft = useSelector(state => state.style.payload.marginLeft)
    const navigate = useNavigate();
    const data = useSelector((state) => state.reels.reels);
    console.log(data);
   
    const getReels = async () => {
        window.start_load();
        const res = await getHighlights({token:Cookie.load('token')});
        // if(!res.succes)
        window.stop_load();
    }
    const columns = useMemo( () => [
        {
            Header: '#',
            accessor: (data, i) => {
                return (i+1)
            }
        },
        {
            Header: 'Video',
            accessor: ((Highlight) => (
                <video width='100%' height={'100px'}>
                <source src={Highlight.vid}  />
                </video>
            ))
        },
        {
            Header: 'title',
            accessor: 'title',
        },
        {
            Header: 'Date',
            accessor: 'date'
        },
        {
            Header: 'Action',
            accessor: (data, i) => 
                (
                    <span id='' className='drop-down'
                    style={{ width: '150px' }}
                    > 
                        <button
                        // id='action'
                        className='form-select'
                         style={{ 
                            fontSize: 12
                          }}
                        onClick={() => {
                            let element = document.getElementById('child'+i);
                            
                            element.classList.toggle('open');
                        }}
                        >
                            Action
                        </button>
                        <div id={'child'+i} class="table-action-box form-control">
                             <button className='btn form-control text-start'
                             style={{ 
                                fontSize: 12
                              }}
                             onClick={() => {
                                Cookie.save('eventItem', JSON.stringify(data));
                                // navigate('/view_store_item');
                             }}
                             > View </button>

                             <button className='btn form-control text-start'
                             style={{ 
                                fontSize: 12
                              }}
                             onClick={() => {
                                Cookie.save('eventItem', JSON.stringify(data));
                                // navigate('/update_store_item');
                             }}
                             > Update </button>
                        </div>
                    </span>
                )
            
        }
    ], [])

    useEffect(() => {
        data.length == 0 && getReels();
        // console.log(data)
        document.title = 'Highlights | Bida Sport Club'
    }, [])
    return data.length > 0 ? (
        <div className=''> 
            {/* <h2> Users </h2> */}
            <MyTable data ={data} columns={columns} pageName = {"Highlights Lists"}
             button = {<button className='btn btn-md btn-color'
             style={{ 
                 // width:'170px',
                 height: '40px'
              }}
             onClick={()=> navigate('/new_highlight')}
             > <FaPlus /> Add Highlight </button>}
            />
        </div>
    ):
    (
        <div className=' row justify-content-center py-5'>
            <h4> <b className="mb-5 ms-5">Highlights List</b> </h4>
            <h3> <p className="mb-5 ms-5 text-center">Highlight List is Empty.</p> </h3>
        </div>
    )
}

export default Highlights